<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.00004 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8C14.6667 4.3181 11.6819 1.33333 8.00004 1.33333C4.31814 1.33333 1.33337 4.3181 1.33337 8C1.33337 11.6819 4.31814 14.6667 8.00004 14.6667Z" fill="#D93025" stroke="#D93025" stroke-width="1.68" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8 5.33333V8" stroke="white" stroke-width="1.68" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8 10.6667H8.00667" stroke="white" stroke-width="1.68" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
